import { Navigate, useLocation } from 'react-router-dom'

const PrivateRoute = ({ isAuthenticated, children }) => {
  const location = useLocation()
  if (isAuthenticated) {
    return children
  }
  return (
    <Navigate
      to={{
        pathname: '/login',
        state: { from: location },
      }}
    />
  )
}

export default PrivateRoute
